import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import Slider from "react-slick";

function WeeklyLeaderboard(props) {
    const { app: {
        brandId
    }, theme } = props;

    const { showOnlyOnFomo } = theme.config;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const settings = {
        loop: true,
        arrows: true,
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        centerPadding: '20px'
    };

    const domain = (brandId == 31 || brandId == 32) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7" : 'IW247';

    return (
        <>
            <InformationWrapper>
                <TitleText>
                    {(brandId === 39 || brandId === 40) ? (
                        <p><span className='brandColor'>Spin, Bet & Climb the Leaderboard!</span> <br />Be among the <span className='brandColor'>Top 10 Weekly Players</span> to win big</p>
                    ) : (
                        <p><span className='brandColor'>Spin, Bet & Climb the Leaderboard!</span> Be among the <span className='brandColor'>Top 10 Weekly Players</span> to win big</p>
                    )}
                </TitleText>
                <ImageWrapper>
                    <Container>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBFirstSec}`}
                            alt="How to participate"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </Container>
                </ImageWrapper>

                {(brandId == 39 || brandId == 40) && <BorderLine></BorderLine>}

                <PriceBreakDown className={(brandId == 39 || brandId == 40) ? 'bgRadial' : ''}>
                    <MainTitle>Prize pool</MainTitle>
                    {(showOnlyOnFomo) ? <UnderLine className='paddingTopBtm'></UnderLine> : ""}
                    <SliderWrapper>
                        <Slider {...settings}>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize1}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize2}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize3}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize4}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize5}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize6}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize7}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize8}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize9}`} /></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBPrize10}`} /></div>
                        </Slider>
                    </SliderWrapper>
                </PriceBreakDown>

                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    {(showOnlyOnFomo) ? <UnderLine className='paddingTopBtm'></UnderLine> : ""}
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBParticipateIcon1}`} />
                            <p>Place bets across qualifying games during the promotional period.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBParticipateIcon2}`} />
                            <p>Earn points and climb the leaderboard.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.weeklyLBParticipateIcon3}`} />
                            <p>Finish in the Top 10 to win weekly cash prizes.</p>
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    {(showOnlyOnFomo) ? <UnderLine className='paddingTopBtm'></UnderLine> : ""}

                    <ul>
                        <li>Leaderboard runs <strong>November 1 to December 31, 2025</strong>.</li>
                        {(brandId === 33 || brandId === 34) ? (
                            <li>Weekly calculation: <strong>Sun-Sat</strong>; prizes credited by Tuesday 5 PM.</li>
                        ) : (
                            <li>Weekly calculation: <strong>Sun-Sat</strong>; prizes credited the following day.</li>
                        )}
                        <li>Lucky prizes credited by <strong>January 7, 2026</strong>.</li>
                        <li>Lucky winners will be contacted through Inbox only.</li>
                        <li>Qualified bets across all games are counted.</li>
                        <li>Standard brand T&Cs apply.</li>
                    </ul>
                </TermsAndCondition>

            </InformationWrapper>
        </>
    )
}



export default withTheme(withAppContext(WeeklyLeaderboard));

const BorderLine = styled.div`
    width: 100%;
    background: ${theme('palette.jiliPlaySpinBorderLineBg')};
    height: 1px;
    align-self: center;
`;

const UnderLine = styled.div`
    height: 1px;
    width: 184px;
    background: radial-gradient(#FFF 0%, rgba(153, 153, 153, 0.00) 80%);

    &.paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    &.marginTop {
        margin: 0 auto;
        margin-top: 1rem;
    }
`;

const SliderWrapper = styled.div`
    width: 85%;
    margin: 0 auto;

    .slick-slide {
        padding: 0 15px;
    }

    .slick-slide img {
        display: block;
        width: 100%;
        transition: transform .5s; /* Animation */

        :hover {
            transform: scale(0.8);
            border: 3px solid #ffffff;
            border-radius: 1rem;
        }

        :focus-visible {
            outline: none;
        }
        :focus {
            outline: none;
        }
    }

    .slick-prev {
        left: -65px;
        top: 43%;
    }

    .slick-next {
        right: -25px;
        top: 43%;
    }

    .slick-prev:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/prevSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-next:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/nextSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-dots {
        bottom: -40px;

        li button:before {
            color: #fff;
            font-size: 15px;
            opacity: unset;
        }

        li.slick-active button:before {
            opacity: unset;
            color: ${theme('palette.slickActiveButtonClr')};
        }
    }
`;

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.weeklyLBMainInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    .boldText {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 700;
    }

    .boldTextLite {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 400;
    }

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }

    .brandColor {
        color: ${theme('palette.weeklyLeaderboardBrandTextColor')};
        font-weight: 700;
    }

    .bgRadial {
        background: ${theme('palette.jiliPlaySpinBgRadial')};
    }
`;

const PriceBreakDown = styled.div`
    width: 80%;
    padding: 2rem 0;
    position: relative;
    margin: auto;
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${theme('palette.liveJackpotTittleTextPadding')};
    position: relative;
    gap: 15px;
    /* margin-bottom: 2rem; */

    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 186.667% */
        text-transform: capitalize;
        margin: 0;
    }

    .mt-10 {
        margin-top: 15px;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
    padding-top: 2rem;

    img {
        width: 93px;
    }

    .customMargin {
        margin: -7px 0px -20px 0px;
    }
`;

const Container = styled.div`
    width: 627px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 100%;
      height: auto;
    }

`;

const MainTitle = styled.h4`
    color: ${theme('palette.weeklySepLeaderboardText')};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;
`;


const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 2rem auto;
    width: 70%;
    height: auto;
`;

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
`;

const KeyDetailsSecBox = styled.div`
    width: 27%;
    height: 190px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    border-radius: ${theme('palette.weeklySepLeaderBoardPartBoxBodrRadus')};
    border: 0.5px solid ${theme('palette.weeklySepLeaderBoardPartBoxBorder')};
    background: ${theme('palette.weeklySepLeaderBoardPartBoxBg')};

    img {
        width: 61px;
    }

    & p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 133.333% */
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`;

const TermsAndCondition = styled.div`
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 2rem auto;
    border-radius: 14px;
    border: ${theme('palette.weeklySepLeaderboardTCBorder')};
    background: ${theme('palette.weeklySepLeaderboardTCBg')};
    padding: 1rem;
    
    ul {
        list-style-type: "✪";
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;

        li {
            color: #fff;
            font-size: 16px;
            text-transform: capitalize;
            padding-left: 5px;
        }
    }
`;